import { render, staticRenderFns } from "./VideoUploadItem.vue?vue&type=template&id=35748c77&scoped=true"
import script from "./VideoUploadItem.vue?vue&type=script&lang=js"
export * from "./VideoUploadItem.vue?vue&type=script&lang=js"
import style0 from "./VideoUploadItem.vue?vue&type=style&index=0&id=35748c77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35748c77",
  null
  
)

export default component.exports